import { render, staticRenderFns } from "./navigation-link-list-view-item.vue?vue&type=template&id=36ca1527&scoped=true"
import script from "./navigation-link-list-view-item.vue?vue&type=script&lang=js"
export * from "./navigation-link-list-view-item.vue?vue&type=script&lang=js"
import style0 from "./navigation-link-list-view-item.vue?vue&type=style&index=0&id=36ca1527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca1527",
  null
  
)

export default component.exports